import React from 'react'
import languages from './languages'



const Skills = () => {

  return (
       
    <div className='mt-2 skills'> 
    <section class="skills" id="skills">
        <div class="max-width">
       < h2 class="title">My skills</h2>
            <div class="skills-content">
                <div class="column left">
                    <div class="text">My creative skills & experiences.</div>
                    <p>My programing skills had been listed with percentage above, 
                    I am always practising and learning some new Technologies randomly.
                    I did my intership program at ITECH in ikorodu Lagos during my service.
                    I have work for 2 tech companies, one at dopemu Lagos as a wordpress Developer
                    and also at Femtech in Ilorin as tech instructor. I have also taken some courses
                    at online school like Udemy,EDX,Domestika,Pirple etc and i have earned certicates in some. 

                   
Secondary school.</p>
                    <a href="#" className='Btn'>Read more</a>
                </div>
                <div class="column right">
                    <div class="bars">
                        <div class="info">
                            <span>HTML</span>
                            <span>90%</span>
                        </div>
                        <div class="line html"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>CSS(BOOSTRAP, TAILWIND, SASS AND LASS)</span>
                            <span>70%</span>
                        </div>
                        <div class="line css"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>JavaScript & JQUERY</span>
                            <span>60%</span>
                        </div>
                        <div class="line js"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>PHP</span>
                            <span>50%</span>
                        </div>
                        <div class="line php"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>MSQL</span>
                            <span>70%</span>
                        </div>
                        <div class="line mysql"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>React & NEXT.JS</span>
                            <span>60%</span>
                        </div>
                        <div class="line react"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>NODEJS</span>
                            <span>60%</span>
                        </div>
                        <div class="line laravel"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>GITLAD & GITHUB</span>
                            <span>60%</span>
                        </div>
                        <div class="line googleapi"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
       <div className='wrapper mx-auto d-flex px-1 justify-content-center flex-wrap'> 
           {
               languages.map(  skills => {
                    if(skills.language){
                        return ( 
                             <div key={skills.id} className='mx-1 mt-1 px-1 lng'
                                  data-bs-toggle='tooltip' title={ skills.description}
                             >
                                  <img 
                                     src={ skills.image }
                                      alt={ skills.language }
                                      className='icon-image'
                                   />
                                   <span> { skills.language } </span>
                              </div>
                          )
                    }
                    else {
                        return (
                            <div className='lng mx-1 px-1 mt-1'
                                 data-bs-toggle='tooltip' title={ skills.description}
                            >
                                 <img  key = { skills.id }
                                        src={ skills.image }
                                        alt='skills'
                                        className='full-image'
                                  />
                             </div>
                             
                        )
                    }
               } )
           }
       </div>
    </div>
  )

}

export default Skills